import { setHomeToRoot } from "~/utils";

export const state = () => ({
  favicon: "",
  menu: null,
  headerData: null,
  footerData: null,
  wmkcData: null,
  baseInfo: {},
  baseImageUrl: process.env,
  askData: null,
  bannerList: [],
  supplyList: [],
});

export const mutations = {
  setState(state, { key, value }) {
    state[key] = value;
  },
};

export const actions = {
  // Keep nuxtServerInit deterministic across routes so that
  // static-generated pages can share identical state payloads.
  nuxtServerInit({ commit }, { app }) {
    const [sitePic] = app.$websiteDataHelper.websitedata.site_pic;
    // 设置图标
    commit("setState", { key: "favicon", value: sitePic?.icourl });

    // 设置菜单
    const menu = app.$websiteDataHelper.headerMenu;
    setHomeToRoot(menu);
    commit("setState", { key: "menu", value: menu });

    // 设置头部和底部数据
    const headerData = app.$websiteDataHelper.getHeaderData();
    const footerData = app.$websiteDataHelper.getFooterData();
    commit("setState", { key: "headerData", value: headerData });
    commit("setState", { key: "footerData", value: footerData });

    // 设置 wmkcData 数据
    const wmkcData = app.$websiteDataHelper.getwmkcData();
    commit("setState", { key: "wmkcData", value: wmkcData });

    // 设置 baseInfo 数据
    const baseInfo = app.$websiteDataHelper.getBaseInfo() || {};
    commit("setState", { key: "baseInfo", value: baseInfo });

    // 设置询盘校验字段
    const [askData] = app.$websiteDataHelper.websitedata.ask_setting;
    commit("setState", { key: "askData", value: askData });

    const bannerList = app.$websiteDataHelper.getpcbanner();
    commit("setState", { key: "bannerList", value: bannerList });

    const supplyList = app.$websiteDataHelper.websitedata.jhy_list || [];
    commit("setState", { key: "supplyList", value: supplyList });
  },
};
